import { AbstractModel } from '@uzurv/core';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class CancellationReason extends AbstractModel {
  @autoserialize
  name: string;

  @autoserialize
  description: string;

  @autoserialize
  useWithRideRequests: boolean;

  @autoserialize
  useWithReservations: boolean;

  @autoserialize
  systemOnly: boolean;
}
